import { useState } from 'react';
import { ImEyeBlocked, ImEye } from 'react-icons/im';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';
import Button from '../components/ui/Button';

const API_URL = import.meta.env.VITE_API_URL || 'https://api.endoac.ro';

export default function RegisterPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // 🔥 previne trimiterea clasică (GET)
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const res = await fetch(`${API_URL}/api/auth/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (!res.ok) {
        const validationMessages = Array.isArray(data?.data)
          ? data.data
              .map((item) => item?.msg || item?.message)
              .filter(Boolean)
              .join(' ')
          : '';
        const message = [data?.message, validationMessages].filter(Boolean).join(' ') || 'Registration failed';
        throw new Error(message);
      }

      const successMessage = data.message || 'Cont creat cu succes! Autentifică-te pentru a continua.';
      setSuccess(successMessage);
      toast.success(successMessage);
      setTimeout(() => navigate('/login'), 1500); // redirect după 1.5s
    } catch (err) {
      setError(err.message);
      toast.error(err.message || 'Nu s-a putut crea contul.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-r from-blue-200 via-blue-300 to-blue-400 flex flex-col">
      <Navbar showHomeOnly={true} />

      <div className="flex flex-1 items-center justify-center px-4 py-10">
        <div className="w-full max-w-md bg-white/90 backdrop-blur-md rounded-2xl shadow-xl p-6 sm:p-8">
          <h2 className="text-2xl sm:text-3xl font-bold text-center text-blue-700 mb-6">
            Creează un cont
          </h2>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Nume complet
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-600 transition"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-600 transition"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Parolă
              </label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-600 transition pr-12"
                  required
                />
                <button
                  type="button"
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-700 hover:text-gray-900"
                  onClick={() => setShowPassword((prev) => !prev)}
                  aria-label={showPassword ? 'Ascunde parola' : 'Arată parola'}
                >
                  {showPassword ? <ImEye className="w-5 h-5" /> : <ImEyeBlocked className="w-5 h-5" />}
                </button>
              </div>
            </div>

            {error && <p className="text-red-600 text-sm">{error}</p>}
            {success && <p className="text-green-600 text-sm">{success}</p>}
            {!success && (
              <p className="text-xs text-gray-500">
                Conturile noi sunt create cu rol de pacient. Un administrator poate actualiza rolul ulterior.
              </p>
            )}

            <Button
              type="submit"
              variant="primary"
              size="lg"
              className="w-full"
              disabled={loading}
            >
              {loading ? 'Se creează contul...' : 'Creează cont'}
            </Button>
          </form>

          <p className="text-center text-gray-600 text-sm mt-4">
            Ai deja cont?{' '}
            <span
              className="text-blue-600 hover:underline cursor-pointer"
              onClick={() => navigate('/login')}
            >
              Autentifică-te
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}
